import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * A page that moved. Sends the old URL to the new one, keeping the route
 * params and the query string: bookmarks, emailed links and an OAuth return
 * (`?connected=true`) all outlive the path they were written for.
 *
 *   <Route path="/nursery/invoices/:id" element={<MovedRoute to="/accounts/invoices/:id" />} />
 */
export default function MovedRoute({ to }: { to: string }) {
  const params = useParams();
  const { search, hash } = useLocation();
  const path = to.replace(/:(\w+)/g, (_, key: string) => params[key] ?? '');
  return <Navigate to={`${path}${search}${hash}`} replace />;
}
